import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { filterTypes } from './constants'

const FilterTypeSelector = ({ onChange, value, disabled }) => {
  const { t } = useTranslation()

  return (
    <div>
      <ComboBox
        fullWidth
        menuItems={filterTypes.map(type => ({
          label: t(type.label),
          value: type.value,
        }))}
        label={t('Filtrar por')}
        value={value}
        handleChange={e => onChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  )
}

export default FilterTypeSelector
